import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    noRepeat: translate({ id: 'recurrenceSettings.recurrenceType.option.noRepeat' }),
    daily: translate({ id: 'recurrenceSettings.recurrenceType.option.daily' }),
    weekly: translate({ id: 'recurrenceSettings.recurrenceType.option.weekly' }),
    monthly: translate({ id: 'recurrenceSettings.recurrenceType.option.monthly' }),
    annually: translate({ id: 'recurrenceSettings.recurrenceType.option.annually' }),
    label: translate({ id: 'recurrenceSettings.recurrenceType.dropdown.label' }),
  }))

  return api
}
